export default __webpack_public_path__ + "static/media/product.e2ec8038.png";